import { Component, Injector, OnInit } from '@angular/core';
import { ChassisFormHandler, PluginDataInterface } from '@kaiser-software/chassis-core';
import { WorkLogModel } from '../../../models/work-log.model';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { WorkLogService } from '../../../services/work-log.service';

@Component({
    selector: 'app-work-logs-create',
    templateUrl: 'create.component.html',
    styleUrls: [ 'create.component.scss' ]
})
export class WorkLogsCreateComponent implements OnInit {

    public form: ChassisFormHandler;

    public model: WorkLogModel = new WorkLogModel();

    protected singular = 'Work log';

    protected plural = 'Work logs';

    protected title = 'Create work log';

    protected routePrefix = 'work-logs';

    protected pluginPrefix = 'eyewatch-work-logs-create';

    protected toolbar;

    protected subject: ReplaySubject<any> = new ReplaySubject();

    protected pluginData: PluginDataInterface;

    /**
     * @param injector
     * @param workLogService
     */
    constructor(private injector: Injector, private workLogService: WorkLogService) {
    }

    public ngOnInit() {
        this.createForm();
        this.setupPlugins();
    }

    protected createForm() {
        this.model = this.workLogService.make();
        this.subject.next(this.model);
        this.form = new ChassisFormHandler(this.injector, 'work-log', this.model);
    }

    protected setupPlugins() {
        this.pluginData = {
            inputs: {
                form: this.form,
                observation: this.subject
            }
        };
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/work-logs/pages/work-logs/create/create.component.ts